export const API_URL = 'https://www.plusapiprod.com';
export const WEB_URL = 'https://rewards.starbucks.co.th';

//export const API_URL = 'https://localhost:7189';
//export const WEB_URL = 'https://localhost:5001';

//export const API_URL = 'https://www.plusapistaging.com';
//export const WEB_URL = 'https://stagingrewards.starbucks.co.th';

export const RECAPTCHAID = '6LeAeCAqAAAAABR0G7fxrXsqDm2DfC3TVfnXLJdl';